export const PRIMARY_CTA_CLASS =
  'btn-primary';

export const SECONDARY_CTA_CLASS =
  'btn-secondary';

export const TEXT_LINK_CLASS =
  'inline-flex min-h-11 items-center text-sm text-accent-soft underline underline-offset-4 hover:text-fg transition-colors md:min-h-0';

export const OFFER_FORM_PATH = '/contact?service=site-web&offre=site-pro';
export const ECOMMERCE_FORM_PATH = '/contact?service=site-web';
